import { SELL_API } from '@services/axiosInstance';
import type { TenantConfigResponse } from '@services/tenantConfig.types';

/**
 * Fetches the tenant's branding + theme configuration from the backend.
 *
 * No try/catch — the promise is allowed to reject so TanStack Query routes the
 * error (the theme hook falls back to defaults on failure so the app still boots).
 */
export const getTenantConfig = async (): Promise<TenantConfigResponse> => {
  const { data } = await SELL_API.get<TenantConfigResponse>('/tenantConfig');
  return data;
};
